/**
 * Зовнішнє посилання з поля `url` (#1230, #1232): лише `http(s)` без облікових даних в адресі — другий
 * рубіж після `normalizeUrl` запису. Інше показується текстом (`urlText`) чи не стає пунктом меню.
 * Малий модуль без React: його беруть `display()`, список, панель пов'язаного й меню «Написати ▾».
 */
import { cleanSearchText, stripControlChars } from '@clientline/contracts/text-rules';

export function externalHref(raw: unknown): string | null {
  if (typeof raw !== 'string' || !/^https?:\/\//i.test(raw)) return null;
  try {
    const url = new URL(raw);
    return url.username || url.password ? null : url.href;
  } catch {
    return null;
  }
}

/**
 * Облікові дані на початку адреси — у показі `•••@`. WHATWG бачить логін і пароль не лише після
 * `схема://`: `\` для `http(s)` — те саме, що `/`, скісних може бути скільки завгодно чи не бути
 * зовсім (`https:/\u:p@h`, `https:\\u:p@h`, `https:u:p@h`, `https:///u:p@h`), а `//u:p@h` — адреса
 * без схеми, і скісних там теж скільки завгодно (рев'ю Security D і F #1271).
 */
const USERINFO = /^([a-z][a-z\d+.-]*:[/\\]*|[/\\]{2,})[^/\\?#]*@/i;

/**
 * Значення `url` для показу текстом (без ↗ і без дописаного `https://`): без керівних символів і
 * символів напрямку (SEC-132, як `safeLine`), облікові дані — `•••@`. Повна адреса — лише в полі
 * правки. Одне джерело для `display()` (дошка, журнал, конфлікт) і посилання, що ним не стало.
 */
export function urlText(raw: string): string {
  // WHATWG викидає `\t`, `\n`, `\r` з будь-якого місця адреси (`ht\ttps://u:p@h` — це `https://u:p@h`),
  // тож і маска бачить адресу без них, а не з пробілами замість них.
  return cleanSearchText(stripControlChars(raw.replace(/[\t\n\r]/g, ''))).replace(
    USERINFO,
    '$1•••@',
  );
}
